(function (root) {
  'use strict';

  function signature(item) {
    return JSON.stringify([Number(item.variant_id || item.id), Object.entries(item.properties || {}).sort(), item.selling_plan_allocation?.selling_plan?.id || null]);
  }

  async function upgradeCart(api, sourceKey, targetId) {
    const before = await api('cart.js');
    const source = before.items.find(item => item.key === sourceKey);
    if (!source || Number(source.product_id) !== 8166460686589) throw new Error('Your cart changed. Please try the upgrade again.');
    const target = { ...source, id: Number(targetId), variant_id: Number(targetId) };
    const matching = (cart, item) => cart.items.filter(line => signature(line) === signature(item));
    const quantity = (cart, item) => matching(cart, item).reduce((sum, line) => sum + line.quantity, 0);
    const targetBefore = quantity(before, target);
    const sourceBefore = quantity(before, source);
    const expectedTarget = targetBefore + source.quantity;
    let added = false;

    try {
      const line = { id: Number(targetId), quantity: source.quantity, properties: source.properties || {} };
      if (source.selling_plan_allocation?.selling_plan?.id) line.selling_plan = source.selling_plan_allocation.selling_plan.id;
      await api('cart/add.js', { items: [line] });
      added = true;
      const current = await api('cart.js');
      const originals = matching(current, source);
      if (originals.length !== 1 || originals[0].quantity !== source.quantity || quantity(current, target) !== expectedTarget) {
        throw new Error('Your cart changed during the upgrade.');
      }
      // Shopify can change line keys when an automatic discount starts or ends.
      const after = await api('cart/change.js', { id: originals[0].key, quantity: 0 });
      if (quantity(after, source) !== sourceBefore - source.quantity || quantity(after, target) !== expectedTarget) {
        throw new Error('Please check your updated cart before continuing.');
      }
      return { cart: after, source, targetId: Number(targetId) };
    } catch (error) {
      // Read the cart after an uncertain response; never blindly repeat an add.
      let current;
      try { current = await api('cart.js'); } catch (_) { throw new Error('Please refresh your cart to check whether the upgrade completed.'); }
      if (quantity(current, source) === sourceBefore - source.quantity && quantity(current, target) === expectedTarget) {
        return { cart: current, source, targetId: Number(targetId) };
      }
      if ((added || quantity(current, target) === expectedTarget) && quantity(current, source) === sourceBefore && quantity(current, target) === expectedTarget) {
        const targets = matching(current, target);
        if (targets.length === 1) {
          try { await api('cart/change.js', { id: targets[0].key, quantity: targetBefore }); }
          catch (_) { throw new Error('The upgrade could not finish. Please check your cart before continuing.'); }
        } else {
          throw new Error('The upgrade could not finish. Please check your cart before continuing.');
        }
      }
      throw new Error(error.message || 'The upgrade could not finish. Please try again.');
    }
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { upgradeCart, signature };
  if (!root.document) return;
  let busy = false;
  root.document.addEventListener('click', async event => {
    const button = event.target.closest('[data-bundle-upgrade]');
    if (!button) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const card = button.closest('.cart-bundle-upgrade');
    const errorBox = card.querySelector('[role="alert"]');
    errorBox.hidden = true;
    const controls = [...root.document.querySelectorAll('#cart-drawer button:not([disabled])')];
    controls.forEach(control => { control.disabled = true; });
    button.textContent = 'Upgrading…';
    card.setAttribute('aria-busy', 'true');
    const api = async (path, body) => {
      const response = await fetch((root.Shopify?.routes?.root || '/') + path, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      let result;
      try { result = await response.json(); }
      catch (_) { throw new Error('Your cart is busy. Please wait a moment and try again.'); }
      if (!response.ok) throw new Error(result.description || 'The upgrade could not finish. Please try again.');
      return result;
    };
    try {
      const result = await upgradeCart(api, button.dataset.sourceKey, button.dataset.targetVariant);
      root.NordLabs.CartDrawer.dispatchCartBoosterTrack('upsell_add', { source: 'bundle_upgrade', fromVariantId: result.source.variant_id, variantId: result.targetId, quantity: result.source.quantity });
      root.NordLabs.CartDrawer.dispatchCartCommerce?.('bundle_upgrade_success', { actionId: button.dataset.cartAnalyticsAction, offerId: 'bundle:' + result.source.variant_id + ':' + result.targetId, fromVariantId: String(result.source.variant_id), variantId: String(result.targetId), quantity: result.source.quantity });
      await root.NordLabs.CartDrawer.refreshCart();
      const heading = root.document.querySelector('#cart-upsells .cart-upsell-label') || root.document.querySelector('#cart-drawer-title');
      heading?.setAttribute('tabindex', '-1');
      heading?.focus({ preventScroll: true });
    } catch (error) {
      root.NordLabs.CartDrawer.dispatchCartCommerce?.('bundle_upgrade_failure', { actionId: button.dataset.cartAnalyticsAction, variantId: String(button.dataset.targetVariant), errorCode: 'unknown' });
      await root.NordLabs.CartDrawer.refreshCart();
      const freshCard = [...root.document.querySelectorAll('.cart-bundle-upgrade')].find(element => element.querySelector('[data-target-variant]')?.dataset.targetVariant === button.dataset.targetVariant);
      const freshError = freshCard?.querySelector('[role="alert"]');
      if (freshError) { freshError.textContent = error.message; freshError.hidden = false; }
    } finally {
      busy = false;
      controls.forEach(control => { if (control.isConnected) control.disabled = false; });
      if (button.isConnected) { button.textContent = '+ Add'; card.removeAttribute('aria-busy'); }
    }
  });
})(typeof window !== 'undefined' ? window : {});
